import { Injectable } from '@angular/core';
import { AuthToken, UserAuthInterface } from '@app/shared/auth/interfaces/auth.interface';
import { JwtHelperService } from '@auth0/angular-jwt';

export const TOKEN_KEY = 'TOKEN';
export const USER_KEY = 'USER';
export const CURRENCY_NAME = 'CURRENCY_NAME';
export const CURRENCY_SYMBOL = 'CURRENCY_SYMBOL';
export const CLIENT_CURRENCY_NAME = 'CLIENT_CURRENCY_NAME';
export const CLIENT_CURRENCY_SYMBOL = 'CLIENT_CURRENCY_SYMBOL';
const APP_PREFIX = 'app-';

@Injectable()
export class LocalStorageService {

  private jwtHelper = new JwtHelperService();

  public setItem(key: string, value: any): void {
    localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
  }

  public getItem(key: string): any {
    return JSON.parse(<string>localStorage.getItem(`${APP_PREFIX}${key}`));
  }

  public deleteItem(key): void {
    localStorage.removeItem(`${APP_PREFIX}${key}`);
  }

  public getToken(): string {
    return this.getItem(TOKEN_KEY);
  }

  public setToken(value: string): void {
    this.setItem(TOKEN_KEY, value);
  }

  public getUser(): UserAuthInterface {
    return this.getItem(USER_KEY);
  }

  public setUser(value: UserAuthInterface): void {
    this.setItem(USER_KEY, value);
  }

  public invalidateToken(): void {
    this.setItem(TOKEN_KEY, null);
  }

  public isTokenValid(): boolean {
    return Boolean(this.getToken());
  }

  public getCurrencyName(): string {
    return this.getItem(CURRENCY_NAME);
  }

  public setCurrencyName(value: string): void {
    this.setItem(CURRENCY_NAME, value);
  }

  public getClientCurrencyName(): string {
    return this.getItem(CLIENT_CURRENCY_NAME);
  }

  public setClientCurrencyName(value: string): void {
    this.setItem(CLIENT_CURRENCY_NAME, value);
  }

  public getCurrencySymbol(): string {
    return this.getItem(CURRENCY_SYMBOL);
  }

  public setCurrencySymbol(value: string): void {
    this.setItem(CURRENCY_SYMBOL, value);
  }

  public setClientCurrencySymbol(value: string): void {
    this.setItem(CLIENT_CURRENCY_SYMBOL, value);
  }

  public invalidateCurrency(): void {
    this.setItem(CURRENCY_NAME, null);
    this.setItem(CURRENCY_SYMBOL, null);
  }

  public getDecodedToken(): AuthToken {
    return this.jwtHelper.decodeToken(this.getToken());
  }
}
